import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  login: true,
  currency: "Vnđ",
  overlay: false,

  selectedCategory: "All",

  baiPhanTich: [
    {
      name: "Tòa 45 - 47 Phan Đăng Lưu",
      file: "sample.pdf",
    },
    {
      name: "Nhừng tòa nhà tiềm năng 100 - 300 tỷ",
      file: "sample2.pdf",
    },
    {
      name: "Khách sạn Quận 1 ",
      file: "sample3.pdf",
    },
    {
      name: "Những toà nhà tiềm năng dưới 200 tỷ ",
      file: "sample4.pdf",
    },
  ],

  products: [
    {
      ma: "1",
      proName: "TOÀ NHÀ VĂN PHÒNG ",
      title: "28 Trần Quốc Thảo",
      address: "28 Trần Quốc Thảo, Phường Xuân Hoà (P.VTS Q3 cũ), TP HCM",
      dienTich:"Ngang 4.5m x Dài 43m Nở hậu 20m, Công nhận 553,3m², DTS 1.922m²",
      ketCau: "Hầm, 7 tầng, Sân thượng",
      giaBan: "350 tỷ",
      hopDong: "800 triệu",
      huong: "Tây Nam",
      phapLy: "CTCP bán 100% cổ phần",
      viTri: "Giữa đường Trần Quốc Thảo và Lý Chính Thắng",
      allPhoto: ["28tqt1.jpg", "28tqt2.jpg", "28tqt3.jpg", "28tqt4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909120663 - Cô Ngân",
    },
    {
      ma: "2",
      proName: "TOÀ NHÀ VĂN PHÒNG ",
      title: "112 Trần Quốc Thảo",
      address: "112 Trần Quốc Thảo, Phường Xuân Hoà (P.VTS Q3 cũ), TP HCM",
      dienTich: "Ngang 14m x Dài 28m, Công nhận 412,09m², DTS 1008,8m²",
      ketCau: "Hầm, 4 tầng, Sân thượng",
      giaBan: "330 tỷ",
      hopDong: "430 triệu",
      huong: "Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Trần Quốc Thảo và Lý Chính Thắng",
      allPhoto: ["112tqt1.jpg", "112tqt2.jpg", "112tqt3.jpg", "112tqt4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 - Nam",
    },
    {
      ma: "3",
      proName: "Biệt Thự Phan Kế Bính",
      title: "20 Phan Kế Bính",
      address: "20 Phan Kế Bính, Phường Sài Gòn (Đakao Q1 cũ), TP HCM",
      dienTich: "Ngang 9m x Dài 25m, Công nhận 224m², DTS 257,81m²",
      ketCau: "2 tầng",
      giaBan: "140 tỷ",
      hopDong: "145 triệu",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Phan Kế Bính với Điện Biên Phủ",
      allPhoto: ["3.1.jpg", "3.2.jpg", "3.3.jpg", "3.4.jpg"],
      categories: ["Biệt thự"],
      chuNha: "0909021800 - Anh Cường",
    },
    {
      ma: "4",
      proName: "Toà Nhà Văn Phòng",
      title: "473 Lê Quang Định",
      address: "473 Lê Quang Định, Phường Hạnh Thông,(P1 Gò Vấp cũ), TP HCM",
      dienTich: "Ngang 8m x Dài 22m, Công nhận 183m², DTS 876m²",
      ketCau: "7 Tầng",
      giaBan: "72 tỷ",
      hopDong: "145 triệu",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Lê Quang Định với Phan Văn Trị",
      allPhoto: ["lqd1.jpg", "lqd2.jpg", "lqd3.jpg", "lqd4.jpg"],
      categories: ["Building"],
      chuNha: "0968473473 - Cát Lê Tiến",
    },
    {
      ma: "5",
      proName: "NHÀ MẶT TIỀN NGUYỄN KHẮC NHU",
      title: "25-27 Nguyễn Khắc Nhu",
      address:"25-27 Nguyễn Khắc Nhu, Phường Cầu Ông Lãnh (Cô Giang Q1cũ), TP HCM",
      dienTich: "Ngang 11m x Dài 29m, Công nhận 290,3m², DTS 600m²",
      ketCau: "3Tầng",
      giaBan: "185 tỷ",
      hopDong: "120 triệu",
      huong: "Đông Bắc",
      phapLy: "Cá nhân",
      viTri: "Nguyễn Khắc Nhu với Nguyễn Thái Học",
      allPhoto: ["nkn1.jpg", "nkn2.jpg", "nkn3.jpg", "nkn4.jpg"],
      categories: ["Building", "Nhà phố"],
      chuNha: "0904263369 - Chị Hằng",
    },
    {
      ma: "6",
      proName: "Khách sạn Quận 1",
      title: "18 Bùi Thị Xuân",
      address: "18 Bùi Thị Xuân, Phường Bến Thành (Quận 1 cũ), TP HCM",
      dienTich: "Ngang 5.3m x Dài 23m, Công nhận 113m², DTS gần 112.8m²",
      ketCau: "Hầm, 12 tầng",
      giaBan: "115",
      hopDong: "400 triệu",
      huong: "Đông Nam",
      phapLy: "cá nhân",
      viTri: "Giữa đường Bùi Thị Xuân với Cách Mạng Tháng Tám",
      allPhoto: ["btx1.jpg", "btx2.jpg", "btx3.jpg", "btx4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0908130269 - Anh Thành",
    },
    {
      ma: "7",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "27-29 Nam Kỳ Khởi Nghĩa",
      address:"27-29 Nam Kỳ Khởi Nghĩa, Phường Sài Gòn (Nguyễn Thái Bình, Quận 1), TP HCM",
      dienTich: "Ngang 8m x Dài 26m, Công nhận 209m², DTS 893,98m²",
      ketCau: "2 Hầm, 6tầng",
      giaBan: "240 tỷ",
      hopDong: "460 triệu/tháng",
      huong: "Đông Bắc",
      phapLy: "Cá Nhân",
      viTri: "Nam Kỳ Khởi Nghĩa với Nguyễn Công Trứ",
      allPhoto: ["nkkn1.jpg", "nkkn2.jpg", "nkkn3.jpg", "nkkn4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0934140266 - Cô Giao",
    },
    {
      ma: "8",
      proName: "NHÀ MẶT TIỀN LÝ TỰ TRỌNG",
      title: "119 Lý Tự Trọng",
      address: "119 Lý Tự Trọng, Phường Bến Thành (Quận 1 cũ), TP HCM",
      dienTich: "Ngang 5,1m x Dài 20,15m, Công nhận 88,6m², DTS 500m²",
      ketCau: "3 tầng",
      giaBan: "120 tỷ",
      hopDong: "200 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá Nhân",
      viTri: "Lý Tự Trọng với Thủ Khoa Huân",
      allPhoto: ["119ltt1.png", "119ltt2.png", "119ltt3.png", "119ltt4.png"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 - Nam",
    },
    {
      ma: "9",
      proName: "BIỆT THỰ NGUYỄN THÀNH Ý",
      title: "2 Nguyễn Thành Ý",
      address: "2 Nguyễn Thành Ý, Phường Tân Định (Dakao,Q1 cũ), TP HCM",
      dienTich: "Ngang 14,5m x Dài 19m, Công nhận 239m², DTS 549m²",
      ketCau: "3 tầng",
      giaBan: "130 tỷ",
      hopDong: "200 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá Nhân",
      viTri: "Nguyễn Thành Ý với Đinh Tiên Hoàng",
      allPhoto: ["9.1.jpg", "9.2.jpg", "9.3.jpg", "9.4.jpg"],
      categories: ["Nhà phố", "Biệt thự"],
      chuNha: "0937888889 - Anh Văn",
    },
    {
      ma: "10",
      proName: "TOÀN NHÀ VĂN PHÒNG",
      title: "2Bis Công Trường Quốc Tế",
      address:"2Bis Công Trường Quốc Tế, Phường Xuân Hoà (VTS, Quận 3 cũ), TP HCM",
      dienTich: "Ngang 15m x Dài 26m, công nhận 366,2m², DTS 2316m²",
      ketCau: "2 Hầm, 8 tầng",
      giaBan: "700 tỷ",
      hopDong: "2 tỷ/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Công Trường Quốc Tế với Trần Cao Vân",
      allPhoto: ["10.1.jpg", "10.2.jpg", "10.3.jpg", "10.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 - Nam",
    },
    {
      ma: "11",
      proName: "Khách sạn Quận 1",
      title: "21 Bùi Thị Xuân",
      address: "21 Bùi Thị Xuân, Phường Bến Thành (Quận 1 cũ), TP HCM",
      dienTich: "Ngang 8m x Dài 16m, công nhận 129m², DTS 923,5m²",
      ketCau: "8 tầng",
      giaBan: "135 tỷ",
      hopDong: "300 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "cá nhân",
      viTri: "Giữa đường Bùi Thị Xuân với Cách Mạng Tháng Tám",
      allPhoto: ["11.1.jpg", "11.2.jpg", "11.3.jpg", "11.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0903315125 - Chị Lan Anh",
      map: "",
    },
    {
      ma: "12",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "546-548 Cách Mạng Tháng 8",
      address:"546-548 Cách Mạng Tháng 8, Phường Nhiêu Lộc (11, Quận 3 cũ), TP HCM",
      dienTich: "Ngang 15m x Dài 36m, Nở hậu 26m , Công nhận 668m², DTS 6000m²",
      ketCau: "2 Hầm 10 tầng",
      giaBan: "450 tỷ",
      hopDong: "900 Triệu/tháng",
      huong: "Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Cách Mạng Tháng 8, với Lê Thị Riêng",
      allPhoto: ["12.1.jpg", "12.2.jpg", "12.3.jpg", "12.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
    {
      ma: "13",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "11Bis Nguyễn Gia Thiều",
      address:"11Bis Nguyễn Gia Thiều, Phường Xuân Hoà (VTS, Quận 3 cũ), TP HCM",
      dienTich: "Ngang 26m x Dài 39m, Công nhận 995m², DTS 4826m²",
      ketCau: "Hầm 10 tầng",
      giaBan: "700 tỷ",
      hopDong: "1,2 tỷ/tháng",
      huong: "Đông Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Gia Thiều, với Nguyễn Đình Chiểu",
      allPhoto: ["13.1.jpg", "13.2.jpg", "13.3.jpg", "13.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0903913332-0903278633-0966204469 - 3 chủ",
      map: "",
    },
    {
      ma: "14",
      proName: "NHÀ MẶT TIỀN BÙI THỊ XUÂN",
      title: "118 Bùi Thị Xuân",
      address: "118 Bùi Thị Xuân, Phường Bến Thành (Quận 1 cũ), TP HCM",
      dienTich: "Ngang 24m x Dài 14m, Công nhận 305m², DTS 493,65m²",
      ketCau: "3 tầng, GPXD Hầm 12 tầng",
      giaBan: "360 tỷ",
      hopDong: "700 Triệu/tháng",
      huong: "Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Bùi Thị Xuân, với Tôn Thất Tùng",
      allPhoto: ["14.1.jpg", "14.2.jpg", "14.3.jpg", "14.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0767700055 - Chú Sơn",
      map: "",
    },
    {
      ma: "15",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "307B Nguyễn Văn Trỗi",
      address:"307B Nguyễn Văn Trỗi, Phường Tân Sơn Nhất (1 Quận TB cũ), TP HCM",
      dienTich: "Ngang 11m x Dài 15m, Công nhận 168,72m², DTS 1262,73m²",
      ketCau: "Hầm 10 tầng",
      giaBan: "155 tỷ",
      hopDong: "1 tỷ/tháng",
      huong: "Đông Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Văn Trồi, với Hoàng Văn THụ",
      allPhoto: ["15.1.jpg", "15.2.jpg", "15.3.jpg", "15.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
    {
      ma: "16",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "11Bis Huỳnh Tịnh Của",
      address: "11Bis Huỳnh Tịnh Của, Phường Xuân Hoà (P. 7 Quận 3 cũ), TP HCM",
      dienTich:"Ngang 13,6m x Dài 31,6m,Thóp hậu 10m, Công nhận 399,3m², DTS 399,3m²",
      ketCau: "2tầng, GPXD 10 tầng",
      giaBan: "238 tỷ",
      hopDong: " Trống Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Huỳnh Tịnh Của, với Trần Quốc Toản ",
      allPhoto: ["16.1.jpg", "16.2.jpg", "16.3.jpg", "16.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0923591616 - Anh Hưng",
      map: "",
    },
    {
      ma: "17",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "111 đường Lý Chính Thắng",
      address:"111 đường Lý Chính Thắng, Phường Xuân Hoà (VTS Quận 3cũ), TP HCM",
      dienTich: "Ngang 11,5m x Dài 29m Nở hậu 12m, Công nhận 336m², DTS 2329m²",
      ketCau: "Hầm 12 tầng",
      giaBan: "330 tỷ",
      hopDong: "700 Triệu/tháng",
      huong: "Tây bắc",
      phapLy: "CTCP Mua bán 100% cổ phần",
      viTri: "Giữa đường Lý Chính Thắng, với Nam Kỳ Khởi Nghĩa",
      allPhoto: ["17.1.jpg", "17.2.jpg", "17.3.jpg", "17.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909023456 - Chị Miên",
      map: "",
    },
    {
      ma: "18",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "485 Tô Ngọc Vân",
      address:"485 Tô Ngọc Vân, Phường Tam Bình (Tam Phú,TP Thủ Đức cũ), TP HCM",
      dienTich: "Ngang 14m x Dài 38m, Công nhận 501.1m², DTS 2.000m²",
      ketCau: "Hầm 4 tầng",
      giaBan: "95 tỷ",
      hopDong: "306 Triệu/tháng",
      huong: "Tây bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Tô Ngọc Vân, với Phú Châu",
      allPhoto: ["18.1.jpg", "18.2.jpg", "18.3.jpg", "18.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
    {
      ma: "19",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "369B Nguyễn Trãi",
      address:"369B Nguyễn Trãi , Phường Cầu Ông Lãnh (Nguyễn Cư Trinh, Quận 1 cũ), TP HCM",
      dienTich: "Ngang 15m x Dài 30m, Công nhận 386,5m², DTS 2.700m²",
      ketCau: "2 Hầm 10 tầng",
      giaBan: "450tỷ",
      hopDong: "1 tỷ 052 Triệu/tháng",
      huong: "Tây bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Trãi, với Nguyễn Văn Cừ",
      allPhoto: ["19.1.jpg", "19.2.jpg", "19.3.jpg", "19.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0942241779 - Cô Quang",
      map: "",
    },
    {
      ma: "20",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "4B Tôn Đức Thắng",
      address: "4B Tôn Đức Thắng, Phường Sài Gòn (Bến Nghé, Quận 1 cũ), TP HCM",
      dienTich: "Ngang 10,2m x Dài 32m, Công nhận 326m², DTS  2938m²",
      ketCau: "2 Hầm 10 tầng",
      giaBan: "450tỷ",
      hopDong: "1 tỷ 400 Triệu/tháng",
      huong: "Đông",
      phapLy: "Đất thuê còn 32 năm. Chưa hoàn công (chủ sẽ hoàn công nếu cần",
      viTri: "Giữa đường Tôn Đức Thắng, với Đinh Tiên Hoàng",
      allPhoto: ["20.1.jpg", "20.2.jpg", "20.3.jpg", "20.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0908411111 - Cô Lâm(Hoa Lâm ",
      map: "",
    },
    {
      ma: "21",
      proName: "BIỆT THỰ LAN ANH VILLAGE",
      title: "C6 Lan Anh Village, Khu Đô Thị Thủ Thiêm",
      address:"C6 Lan Anh Village, Khu Đô Thị Thủ Thiêm, Phường An Khánh (P. cũ: Thủ Thiêm), TP. Thủ Đức, TP.HCM",
      dienTich: "Ngang 15m x Dài 24,9m, Công nhận 372,8m², DTS 217,2m²",
      ketCau: "3 tầng",
      giaBan: "200tỷ",
      hopDong: "140 Triệu/tháng",
      huong: "Đông",
      phapLy: "Cá nhân",
      viTri: "Giữa đường C6 Lan Anh Village, Khu Đô Thị Thủ Thiêm",
      allPhoto: ["21.1.jpg", "21.2.jpg", "21.3.jpg", "21.4.jpg"],
      categories: ["Nhà phố", "Biệt thự"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
    {
      ma: "22",
      proName: "CĂN HỘ DỊCH VỤ",
      title: "42/4 Hồ Hảo Hớn",
      address:"42/4 Hồ Hảo Hớn, Phường Cầu Ông Lãnh (P. Cô Giang, Quận 1 cũ), TP.HCM",
      dienTich: "Ngang 5,43m x Dài 22,19m, Công nhận 323,2m², DTS 884,4m²",
      ketCau: "5 tầng",
      giaBan: "140 ỷ",
      hopDong: "1 tỷ/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Hồ Hảo Hớn, với Cô Giang",
      allPhoto: ["22.1.jpg", "22.2.jpg", "22.3.jpg", "22.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
    {
      ma: "23",
      proName: "BIỆT THỰ NGUYỄN THÔNG",
      title: "8 Nguyễn Thông",
      address: "8 Nguyễn Thông, Phường Xuân Hoà (P.VTS, Quận 3 cũ), TP.HCM",
      dienTich: "Ngang 15m x Dài 26m , Công nhận 341m²  DTS 1136,60m²",
      ketCau: "Hầm 6 tầng",
      giaBan: "250 tỷ",
      hopDong: "chủ đang ở tỷ/tháng",
      huong: "Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Thông, với Điện Biên Phủ",
      allPhoto: ["23.1.jpg", "23.2.jpg", "23.3.jpg", "23.4.jpg"],
      categories: ["Nhà phố", "Biệt thự"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
    {
      ma: "24",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "59 Ngô Thời Nhiệm",
      address: "59 Ngô Thời Nhiệm, Phường Xuân Hoà (P.VTS, Quận 3 cũ), TP.HCM",
      dienTich: "Ngang 6m x Dài 15m , Công nhận 90m², DTS 500m²",
      ketCau: "Hầm 6 tầng",
      giaBan: "76 tỷ",
      hopDong: "120 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Ngô Thời Nhiệm, với Bà Huyện Thanh Quan",
      allPhoto: ["24.1.jpg", "24.2.jpg", "24.3.jpg", "24.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0906781963 - Cô Nga",
      map: "",
    },
    {
      ma: "25",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "569 Nguyễn Đình Chiểu",
      address: "569 Nguyễn Đình Chiểu, Phường Bàn Cờ (P.2, Quận 3 cũ), TP.HCM",
      dienTich: "Ngang 8,41m x Dài 9,55m, Công nhận 75,6m², DTS 430m²",
      ketCau: "8 tầng",
      giaBan: "78 tỷ",
      hopDong: "140 Triệu/tháng",
      huong: "Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Đình Chiểu, với Nguyễn Thiện Thuật",
      allPhoto: ["25.1.jpg", "25.2.jpg", "25.3.jpg", "25.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
    {
      ma: "26",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "100 Nguyễn Du",
      address: "100 Nguyễn Du, Phường Sài Gòn (P.Bến Nghé, Quận 1 cũ), TP.HCM",
      dienTich: "Ngang 11,75m x Dài 31m, Công nhận 364,2m², DTS 906,65m²",
      ketCau: " Hầm 4 tầng, (Xây dựng trên 10 tầng)",
      giaBan: "420 tỷ",
      hopDong: "520 Triệu/tháng",
      huong: "Đông Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Du, với Nam Kỳ Khởi Nghĩa",
      allPhoto: ["26.1.jpg", "26.2.jpg", "26.3.jpg", "26.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0933241297 - Chị Hạnh",
      map: "",
    },
    {
      ma: "27",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "11 Nguyễn Huy Tưởng",
      address: "11 Nguyễn Huy Tưởng, Phường Gia Định (P.6, Quận BT cũ), TP.HCM",
      dienTich: "Ngang 12m x Dài 20m , Công nhận 227,2m², DTS 1500m²",
      ketCau: " Hầm 7 tầng",
      giaBan: "105 tỷ",
      hopDong: "330 Triệu/tháng",
      huong: "Đông",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Huy Tưởng, với Phan Đăng Lưu",
      allPhoto: ["27.1.jpg", "27.2.jpg", "27.3.jpg", "27.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0983216335 - Anh Hưng",
      map: "",
    },
    {
      ma: "28",
      proName: "BIỆT THỰ TRẦN KHÁNH DƯ",
      title: "7 Trần Khánh Dư",
      address:"7 Trần Khánh Dư, Phường Tân Định (P.Tân Định, Quận 1 cũ), TP.HCM",
      dienTich: "Ngang 14,1m x Dài 26,05m, Công nhận 367m², DTS 500m²",
      ketCau: " 3 tầng",
      giaBan: "165 tỷ",
      hopDong: "150 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Trần Khánh Dư, với Hoàng Sa",
      allPhoto: ["28.1.jpg", "28.2.jpg", "28.3.jpg", "28.4.jpg"],
      categories: ["Nhà phố", "Biệt thự"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
    {
      ma: "29",
      proName: "KHÁCH SẠN LÊ THÁNH TÔN",
      title: "42 Lê Thánh Tôn",
      address:"42 Lê Thánh Tôn, Phường Sài Gòn (P.Bến Nghé, Quận 1 cũ), TP.HCM",
      dienTich: "Ngang 4,4m x Dài 21m, Công nhận 92,4m², DTS 626,6m²",
      ketCau: " Hầm 8 tầng",
      giaBan: "120 tỷ",
      hopDong: "240 Triệu/tháng",
      huong: "Đông Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Lê Thánh Tôn, với Thái Văn Lung",
      allPhoto: ["29.1.jpg", "29.2.jpg", "29.3.jpg", "29.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909901809 - Chị Huyền",
      map: "",
    },
    {
      ma: "30",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "290 Nam Kỳ Khởi Nghĩa",
      address:"290 Nam Kỳ Khởi Nghĩa, Phường Xuân Hoà (P.8, Quận 3 cũ), TP.HCM",
      dienTich: "Ngang 22m x Dài 16,8m, Công nhận 368m², DTS 4693,8m²",
      ketCau: "2 Hầm 14 tầng",
      giaBan: "715 tỷ",
      hopDong: "1,58 tỷ/tháng",
      huong: "Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nam Kỳ Khởi Nghĩa, với Đặng Dung",
      allPhoto: ["30.1.jpg", "30.2.jpg", "30.3.jpg", "30.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0987172888 - Chị Thành",
      map: "",
    },
    {
      ma: "31",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "121 Võ Thị Sáu",
      address: "121 Võ Thị Sáu, Phường Xuân Hoà (P.VTS, Quận 3 cũ), TP.HCM",
      dienTich: "Ngang 14m x Dài 24m, Công nhận 347,2m², DTS 1200m²",
      ketCau: "4 tầng, GPXD Hầm 10 tầng",
      giaBan: "185 tỷ",
      hopDong: "200 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Võ Thị Sáu, với Pasteur",
      allPhoto: ["31.1.jpg", "31.2.jpg", "31.3.jpg", "31.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
    {
      ma: "32",
      proName: "NHÀ MẶT TIỀN TRẦN QUỐC THẢO",
      title: "125A Trần Quốc Thảo",
      address:"125A Trần Quốc Thảo, Phường Xuân Hoà (P.VTS, Quận 3 cũ), TP.HCM",
      dienTich: "Ngang 14m x Dài 40m, Công nhận 534,3m², DTS 961m²",
      ketCau: "Hầm 3 tầng",
      giaBan: "350 tỷ",
      hopDong: "400 Triệu/tháng",
      huong: "Đông Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Trần Quốc Thảo, với Lý Chính Thắng",
      allPhoto: ["32.1.jpg", "32.2.jpg", "32.3.jpg", "32.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
    {
      ma: "33",
      proName: "NHÀ MẶT TIỀN LÝ CHÍNH THẮNG",
      title: "39 Lý Chính Thắng",
      address: "39 Lý Chính Thắng, Phường Xuân Hoà (P.VTS, Quận 3 cũ), TP.HCM",
      dienTich: "Ngang 4m x Dài 26m, Công nhận 102m², DTS 637.6m²",
      ketCau: "8 tầng",
      giaBan: "41 tỷ",
      hopDong: "100 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Lý Chính Thắng, với Nam Kỳ Khởi Nghĩa",
      allPhoto: ["33.1.jpg", "33.2.jpg", "33.3.jpg", "33.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0977775577 - Anh Khánh",
      map: "",
    },
    {
      ma: "34",
      proName: "NHÀ MẶT VÕ VĂN TẦN",
      title: "291 Võ Văn Tần",
      address: "291 Võ Văn Tần, Phường Bàn Cờ (P.5, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 7,3m x Dài 13m, Nở hậu 9,5m, Công nhận 86,7m², DTS 637.6m²",
      ketCau: "4 tầng",
      giaBan: "65 tỷ",
      hopDong: "180 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Võ Văn, với Cách Mạng Tháng Tám",
      allPhoto: ["34.1.jpg", "34.2.jpg", "34.3.jpg", "34.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0935185475 - Anh Trí",
      map: "",
    },
    {
      ma: "35",
      proName: "NHÀ MẶT 3 THÁNG 2 ",
      title: "33-35 đường 3 Tháng 2",
      address:"33-35 đường 3 Tháng 2, Phường Hoà Hưng (P.11, Quận 10 cũ), TP.HCM",
      dienTich: "Ngang 18m x Dài 25m, Nở hậu 24m, Công nhận 499m², DTS 1300m²",
      ketCau: "4 tầng",
      giaBan: "290 tỷ",
      hopDong: "300 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường 3 tháng 2, với Cách Mạng Tháng Tám",
      allPhoto: ["35.1.jpg", "35.2.jpg", "35.3.jpg", "35.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0989139448 - Chị Nhung",
      map: "",
    },
    {
      ma: "36",
      proName: "NHÀ MẶT BÙI ĐÌNH TUÝ ",
      title: "184 Bùi Đình Tuý",
      address: "184 Bùi Đình Tuý, Phường Bình Thạnh (P.12, Quận BT cũ), TP.HCM",
      dienTich: "Ngang 6,2m x Dài 26,2m, Công nhận 165m², DTS 321m²",
      ketCau: "Hầm 6 tầng",
      giaBan: "45 tỷ",
      hopDong: "130 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Bùi Đình Tuý với Nơ Trang Long",
      allPhoto: ["36.1.jpg", "36.2.jpg", "36.3.jpg", "36.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0918172176 - Cô Thuý",
      map: "",
    },
    {
      ma: "37",
      proName: "NHÀ MẶT LƯƠNG HỮU KHÁNH",
      title: "14 Lương Hữu Khánh",
      address: "14 Lương Hữu Khánh, Phường Bến Thành (P.BT, Quận 1 cũ), TP.HCM",
      dienTich: "Ngang 6m x Dài 22m, Nở hậu 6,9m, Công nhận 119m², DTS 623,4m²",
      ketCau: "Hầm 9 tầng",
      giaBan: "65 tỷ",
      hopDong: "180 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Lương Hữu Khánh với Nguyễn Trãi",
      allPhoto: ["37.1.jpg", "37.2.jpg", "37.3.jpg", "37.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0903855652 - Anh Huấn",
      map: "",
    },
    {
      ma: "38",
      proName: "NHÀ MẶT TÔ HIẾN THÀNH",
      title: "185-185A Tô Hiến Thành",
      address:"185-185A Tô Hiến Thành, Phường Hoà Hưng (P.13, Quận 10 cũ), TP.HCM",
      dienTich:"Ngang 9,3m x Dài 25m, Thóp hậu 8,7m, Công nhận 232m², DTS 1100m²",
      ketCau: "6 tầng",
      giaBan: "137 tỷ",
      hopDong: "0 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Tô Hiến Thành với Thành Thái",
      allPhoto: ["38.1.jpg", "38.2.jpg", "38.3.jpg", "38.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0918022357 - Anh Tùng",
      map: "",
    },
    {
      ma: "39",
      proName: "NHÀ MẶT PHAN XÍCH LONG",
      title: "169-171 Phan Xích Long",
      address:"169-171 Phan Xích Long, Phường Cầu Kiệu (P.2, Quận PN cũ), TP.HCM",
      dienTich: "Ngang 16m x Dài 16m, Công nhận 256m², DTS 800m²",
      ketCau: "4 tầng",
      giaBan: "193 tỷ",
      hopDong: "300 Triệu/tháng",
      huong: "Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Phan Xích Long với Phan Đăng Lưu",
      allPhoto: ["39.1.jpg", "39.2.jpg", "39.3.jpg", "39.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0977402200 - Trân Anh - 0767662597 Anh Khánh",
      map: "",
    },
    {
      ma: "40",
      proName: "BIỆT THỰ TRẦN ĐÌNH XU",
      title: "35/11 Trần Đình Xu",
      address:"35/11 Trần Đình Xu, Phường Cầu Ông Lãnh (P.Ccầu Kho, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 14,69 m x Dài 18m, Nở hậu 20m, Công nhận  320,8m², DTS 148,4m²",
      ketCau: "2 tầng",
      giaBan: "82 tỷ",
      hopDong: "80 Triệu/tháng",
      huong: "Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Trần Đình Xu với Nguyễn Cư Trinh",
      allPhoto: ["40.1.jpg", "40.2.jpg", "40.3.jpg", "40.4.jpg"],
      categories: ["Nhà phố", "Biệt thự"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
     {
      ma: "41",
      proName: "NHÀ MẶT TIỀN NAM KỲ KHỞI NGHĨA",
      title: "191 Nam Kỳ Khởi Nghĩa",
      address: "191 Nam Kỳ Khởi Nghĩa, Phường Xuân Hoà (P.VTS, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 6,12m x Dài 22,44m, Nở hậu 6,37m, Công nhận 137m², DTS 884,39m²",
      ketCau: "Hầm 8 tầng",
      giaBan: "150 tỷ",
      hopDong: "460 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nam Kỳ Khởi Nghĩa với Lý Chính Thắng",
      allPhoto: ["41.1.jpg", "41.2.jpg", "41.3.jpg", "41.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909507119 - Anh Trung - 0938093093 - Anh Cường ",
      map: "",
    },
     {
      ma: "42",
      proName: "NHÀ MẶT TIỀN NGÔ THỜI NHIỆM",
      title: "15-17 Ngô Thời Nhiệm",
      address: "15-17 Ngô Thời Nhiệm, Phường Xuân Hoà (P.VTS, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 22m x Dài 16m, Công nhận 336m², DTS 301,1m²",
      ketCau: "2 tầng, GPXD Hầm 7 tầng",
      giaBan: "270 tỷ",
      hopDong: "150 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Ngô Thời Nhiệm với Trần Quốc Thảo",
      allPhoto: ["42.1.jpg", "42.2.jpg", "42.3.jpg", "42.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909120663 - Cô Nga",
      map: "",
    },
    {
      ma: "43",
      proName: "NHÀ MẶT LÊ NGÔ CÁT",
      title: "2 Lê Ngô Cát",
      address: "2 Lê Ngô Cát, Phường Xuân Hoà (P.VTS, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 9m x Dài 32m, nở hậu 13m, Công nhận 320,9m², DTS m²",
      ketCau: "Đất trống, GPXD Hầm 7 tầng",
      giaBan: "148 tỷ",
      hopDong: " Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Lê Ngô Cát với Nguyễn Đình Chiểu",
      allPhoto: ["43.1.jpg", "43.2.jpg", "43.3.jpg", "43.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
    {
      ma: "44",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "110-112 Bát Nàn,",
      address: "110-112 Bát Nàn,, Phường Cát Lái (P Thạnh Mỹ Lợi, Quận 2 cũ), TP.HCM",
      dienTich:"Ngang 28m x Dài 21m, Công nhận 569m², DTS 2.659m²m²",
      ketCau: "Hầm 7 tầng",
      giaBan: "300 tỷ",
      hopDong: "550 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Bát Nà với LK7-40 & LK7-41 Sài Gòn Mystery Villas",
      allPhoto: ["44.1.jpg", "44.2.jpg", "44.3.jpg", "44.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 - Nam",
      map: "",
    },
    {
      ma: "45",
      proName: "NHÀ MẶT ĐIỆN BIÊN PHỦ",
      title: "199 Điện Biên Phủ",
      address: "199 Điện Biên Phủ, Phường Xuân Hoà (P.VTS, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 9,5m x Dài 18m, Công nhận 166,3m², DTS 1850 m²",
      ketCau: "9 tầng",
      giaBan: "130 tỷ",
      hopDong: "250Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Điện Biên Phủ với Mạc Đỉnh Chi",
      allPhoto: ["45.1.jpg", "45.2.jpg", "45.3.jpg", "45.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0939136666 - A Tùng",
      map: "",
    },
    {
      ma: "46",
      proName: "NHÀ MẶT ĐIỆN BIÊN PHỦ",
      title: "46 Điện Biên Phủ",
      address: "46 Điện Biên Phủ, Phường Tân Định (P.Đakao, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 7,95m x Dài 16m, nở hậu 8,03m, Công nhận 132m², DTS 250m²",
      ketCau: "2 tầng",
      giaBan: "95 tỷ",
      hopDong: "60 Triệu/tháng",
      huong: "Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Điện Biên Phủ với Mạc Đỉnh Chi",
      allPhoto: ["46.1.jpg", "46.2.jpg", "46.3.jpg", "46.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909255825 - Chú Đại",
      map: "",
    },
    {
      ma: "47",
      proName: "NHÀ MẶT CÁCH MẠNG THÁNG TÁM",
      title: "123 Cách Mạng Tháng Tám",
      address: "123 Cách Mạng Tháng Tám, Phường Bến Thành (P.Bến Thành, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 8m x Dài 15m, Công nhận 103m², DTS 500m²",
      ketCau: "4 tầng",
      giaBan: "110 tỷ",
      hopDong: "250 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Cách Mạng Tháng Tám với Nguyễn Thị Minh Khai",
      allPhoto: ["47.1.jpg", "47.2.jpg", "47.3.jpg", "47.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0901338807 - Anh Lộc",
      map: "",
    },
     {
      ma: "48",
      proName: "NHÀ MẶT TIỀN CHDV ĐƯỜNG GIẢI PHÓNG",
      title: "18 Giải Phóng,",
      address: "18 Giải Phóng, Phường Tân Sơn Nhất  (P.4, Quận Tân Bình cũ), TP.HCM",
      dienTich:"Ngang 7,4m x Dài 30m, Công nhận 211m², DTS 500m²",
      ketCau: "7 tầng",
      giaBan: "57 tỷ",
      hopDong: "220 Triệu/tháng",
      huong: "Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Giải Phóng với Thăng Long",
      allPhoto: ["48.1.jpg", "48.2.jpg", "48.3.jpg", "48.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: " 0989474747- Anh Tuấn",
      map: "",
    },
     {
      ma: "49",
      proName: "NHÀ MẶT TIỀN CHDV ĐƯỜNG TRƯƠNG QUYỀN",
      title: "22 Trương Quyền",
      address: "22 Trương Quyền, Phường Xuân Hoà  (P.VTS, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 4,5m x Dài 20,5m, Công nhận 101,5m², DTS 552,3m²",
      ketCau: "7 tầng",
      giaBan: "50 tỷ",
      hopDong: "147 Triệu/tháng",
      huong: "Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Giải Phóng với Thăng Long",
      allPhoto: ["49.1.jpg", "49.2.jpg", "49.3.jpg", "49.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: " 0903919461- Chị Mưa",
      map: "",
    },
    {
      ma: "50",
      proName: "NHÀ MẶT TIỀN MỸ GIANG",
      title: "29 Mỹ Giang 2B",
      address: "29 Mỹ Giang 2B, Phường Tân Hưng (P.Tân Phong, Quận 7 cũ), TP.HCM",
      dienTich:"Ngang 11m x Dài 18m, Công nhận 195m², DTS 450m²",
      ketCau: "3 tầng",
      giaBan: "80 tỷ",
      hopDong: " Triệu/tháng",
      huong: "Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Mỹ Giang 2B với Đường 0 ",
      allPhoto: ["50.1.jpg", "50.2.jpg", "50.3.jpg", "50.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: " 0909762672- Nam",
      map: "",
    },
    {
      ma: "51",
      proName: "NHÀ MẶT TIỀN NGUYỄN VĂN HƯỞNG",
      title: "189A1 Nguyễn Văn Hưởng",
      address: "189A1 Nguyễn Văn Hưởng, Phường An Khánh (P.Thảo Điền, Quận 2 cũ), TP.HCM",
      dienTich:"Ngang 15m x Dài 70m, Công nhận 669m² (thực tế 1044m²), DTS 1200m²",
      ketCau: "3 tầng",
      giaBan: "320 tỷ",
      hopDong: " Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Văn Hưởng với Đường 188 Nguyễn Văn Hưởng",
      allPhoto: ["51.1.jpg", "51.2.jpg", "51.3.jpg", "51.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: " 0909762672- Nam",
      map: "",
    },
     {
      ma: "52",
      proName: "NHÀ MẶT TIỀN NGUYỄN THỊ MINH KHAI",
      title: "376 Nguyễn Thị Minh Khai",
      address: "376 Nguyễn Thị Minh Khai, Phường Bàn Cờ (P.5, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 6m x Dài 9m, nở hậu 7m. Công nhận 49m², DTS 160m²",
      ketCau: "5 tầng",
      giaBan: "35 tỷ",
      hopDong: "100 Triệu/tháng",
      huong: "Đông Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Thị Minh Khai với Đường Cách Mạng Tháng Tám",
      allPhoto: ["52.1.jpg", "52.2.jpg", "52.3.jpg", "52.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: " 090 3703483- Anh Khiêm - 090 3881404 Chị Lan",
      map: "",
    },
    {
      ma: "53",
      proName: "NHÀ MẶT TIỀN LÊ LAI",
      title: "80 Lê Lai",
      address: "80 Lê Lai, Phường Sài Gòn (P.Bến Thành, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 4m x Dài 20m, Công nhận 80m², DTS 600m²",
      ketCau: "5 tầng",
      giaBan: "80 tỷ",
      hopDong: "100 Triệu/tháng",
      huong: "Đông Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Lê Lai với Đường Nguyễn Thị Nghĩa",
      allPhoto: ["53.1.jpg", "53.2.jpg", "53.3.jpg", "53.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: " 090 8237065- Anh Hùng",
      map: "",
    },
     {
      ma: "54",
      proName: "NHÀ MẶT TIỀN TÔN THẤT TÙNG",
      title: "15 Tôn Thất Tùng",
      address: "15 Tôn Thất Tùng, Phường Bến Thành (P.Phạm Ngũ Lão, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 4,08m x Dài 18m, Công nhận 73,44m², DTS 215,9m²",
      ketCau: "3 tầng",
      giaBan: "44 tỷ",
      hopDong: "80 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Tôn Thất Tùng với Đường Nguyễn Thị Minh Khai",
      allPhoto: ["54.1.jpg", "54.2.jpg", "54.3.jpg", "54.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0918122518- Anh Hải",
      map: "",
    },
    {
      ma: "55",
      proName: "NHÀ MẶT TIỀN BÙI THỊ XUÂN",
      title: "87b Bùi Thị Xuân",
      address: "87B Bùi Thị Xuân, Phường Bến Thành (P.Phạm Ngũ Lão, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 6m x Dài 27m, Công nhận 127m², DTS 828,5m²",
      ketCau: "Hầm 7 tầng",
      giaBan: "78 tỷ",
      hopDong: "250 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Bùi Thị Xuân với Đường Cống Quỳnh",
      allPhoto: ["55.1.jpg", "55.2.jpg", "55.3.jpg", "55.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0975737879- Anh Sơn",
      map: "",
    },
     {
      ma: "56",
      proName: "NHÀ MẶT TIỀN PHAN XÍCH LONG",
      title: "37A Phan Xích Long",
      address: "37A Phan Xích Long, Phường Đức Nhuận (P.3, Quận Phú Nhuận cũ), TP.HCM",
      dienTich:"Ngang 9,3m x Dài 30m, Công nhận 241,4m², DTS 1496m²",
      ketCau: "Hầm 8 tầng",
      giaBan: "95 tỷ",
      hopDong: "250 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Phan Xích Long với Đường Phan Đăng Lưu",
      allPhoto: ["56.1.jpg", "56.2.jpg", "56.3.jpg", "56.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0908443348- Anh Khoa",
      map: "",
    },
    {
      ma: "57",
      proName: "NHÀ MẶT TIỀN HAI BÀ TRƯNG",
      title: "270-272 Hai Bà Trung",
      address: "270-272 Hai Bà Trưng, Phường Tân Định (P.Tân Định, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 8,5m x Dài 25m, Nở hậu 12,3m, Công nhận 225m², DTS 489m²",
      ketCau: "3 tầng",
      giaBan: "225 tỷ",
      hopDong:"350 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Hai Bà Trưng với Đường Đinh Công Tráng",
      allPhoto: ["57.1.jpg", "57.2.jpg", "57.3.jpg", "57.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0767809595- Vy con chị Trâm",
      map: "",
    },
     {
      ma: "58",
      proName: "NHÀ MẶT TIỀN CỘNG HOÀ",
      title: "119-119A Cộng Hoà",
      address: "119-119A Cộng Hoà, Phường Bảy Hiền (P.12, Quận Tân Bình cũ), TP.HCM",
      dienTich:"Ngang 8,2m x Dài 31,5m, Công nhận 240m², DTS 1200m²",
      ketCau: "Hầm 5 tầng",
      giaBan: "107 tỷ",
      hopDong:"400-500 Triệu/tháng",
      huong: "Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Cộng Hoà với Đường Hoàng Hoa Thám",
      allPhoto: ["58.1.jpg", "58.2.jpg", "58.3.jpg", "58.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0907007007- Anh Phong - 0987007007 Chị Nguyệt",
      map: "",
    },
    {
      ma: "59",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "138A Nguyễn Văn Trỗi",
      address: "138A Nguyễn Văn Trỗi, Phường Phú Nhuận (P.8, Quận Phú Nhuận cũ), TP.HCM",
      dienTich:"Ngang 20m x Dài 23m, Công nhận 471m², DTS 2800m²",
      ketCau: "Hầm 8 tầng",
      giaBan: "400 tỷ",
      hopDong:"900 Triệu/tháng",
      huong: "Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Văn Trỗi với Đường Nguyễn Trọng Tuyển",
      allPhoto: ["59.1.jpg", "59.2.jpg", "59.3.jpg", "59.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "090 8823378- Anh Long MGĐQ",
      map: "",
    },
    {
      ma: "60",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "259A Nguyễn Văn Trỗi",
      address: "259A Nguyễn Văn Trỗi, Phường Phú Nhuận (P.10, Quận Phú Nhuận cũ), TP.HCM",
      dienTich:"Ngang 23m x Dài 12m, Công nhận 160m², DTS 970m²",
      ketCau: "Hầm 7 tầng",
      giaBan: "270 tỷ",
      hopDong:"800 Triệu/tháng",
      huong: "Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Văn Trỗi với Đường Trương Quốc Dung",
      allPhoto: ["60.1.jpg", "60.2.jpg", "60.3.jpg", "60.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0903731111- Anh Thuận",
      map: "",
    },
    {
      ma: "61",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "183C Nguyễn Văn Đậu",
      address: "183C Nguyễn Văn Đậu, Phường Bình Lợi Trung (P.11, Quận Bình Thạnh cũ), TP.HCM",
      dienTich:"Ngang 9,1m x Dài 35m, Công nhận 282m², DTS 1630m²",
      ketCau: "Hầm 7 tầng",
      giaBan: "85 tỷ",
      hopDong:"250 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Văn Đậu với Đường Lê Quang Định",
      allPhoto: ["61.1.jpg", "61.2.jpg", "61.3.jpg", "61.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909288717- Anh Tân",
      map: "",
    },
     {
      ma: "62",
      proName: "NHÀ MẶT TIỀN HAI BÀ TRƯNG",
      title: "371/3-5 Hai Bà Trưng",
      address: "371/3-5 Hai Bà Trưng, Phường Xuân Hoà (P.Võ Thị Sáu, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 11m x Dài 22m, Công nhận 240m², DTS m²",
      ketCau: "GPXD Hầm 7 tầng",
      giaBan: "87 tỷ",
      hopDong:"Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Hai Bà Trưng với Đường Trần Quang Khải",
      allPhoto: ["62.1.jpg", "62.2.jpg", "62.3.jpg", "62.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909610917- Melissa Le",
      map: "",
    },
     {
      ma: "63",
      proName: "NHÀ MẶT TIỀN BÙI VIỆN",
      title: "250 Bùi Viện",
      address: "250-252-260/8-260/10 Bùi Viện, Phường Bến Thành (P.Phạm Ngũ Lão, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 7m x Dài 16m, Nở hậu 8,6m, Công nhận 113,54m², DTS 560m²",
      ketCau: "5 tầng",
      giaBan: "75 tỷ",
      hopDong:"130 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Bùi Viện với Đường Trần Hưng Đạo",
      allPhoto: ["63.1.jpg", "63.2.jpg", "63.3.jpg", "63.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672- Anh Nam",
      map: "",
    },
    {
      ma: "64",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "40 Hoàng Việt",
      address: "40 Hoàng, Phường Tân Sơn Nhất (P.4, Quận Tân Bình cũ), TP.HCM",
      dienTich:"Ngang 12m x Dài 20m, Công nhận 240m², DTS 2.200m²",
      ketCau: "Hầm 10 tầng",
      giaBan: "158 tỷ",
      hopDong:"370 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Sổ Hồng- Pháp Nhân công ty",
      viTri: "Giữa đường Hoàng Việt với Đường Lê Bình",
      allPhoto: ["64.1.jpg", "64.2.jpg", "64.3.jpg", "64.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672- Anh Nam",
      map: "",
    },
     {
      ma: "65",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "218Bis Nam Kỳ Khởi Nghĩa",
      address: "218Bis Nam Kỳ Khởi Nghĩa, Phường Xuân Hoà (P.Võ Thị Sáu, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 10,9m x Dài 15m, Công nhận 116,5m², DTS 932m²",
      ketCau: "7 tầng",
      giaBan: "170 tỷ",
      hopDong:"380 Triệu/tháng",
      huong: "Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nam Kỳ Khởi Nghĩa với Điện Biên Phủ",
      allPhoto: ["65.1.jpg", "65.2.jpg", "65.3.jpg", "65.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "090303707- Anh Thanh",
      map: "",
    },
     {
      ma: "66",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "27-27A Kỳ Đồng",
      address: "27-27A Kỳ Đồng, Phường Xuân Hoà (P.Võ Thị Sáu, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 17m x Dài 35m, Công nhận 590m², DTS 5.000m²",
      ketCau: "2 Hầm 12 tầng",
      giaBan: "460 tỷ",
      hopDong:"900 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nam Kỳ Khởi Nghĩa với Điện Biên Phủ",
      allPhoto: ["66.1.jpg", "66.2.jpg", "66.3.jpg", "66.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: " 0938308218 ĐD Chị Liên 0917244380- Anh Hiệp",
      map: "",
    },
     {
      ma: "67",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "20-22-24 Huỳnh Mẫn Đạt",
      address: "20-22-24 Huỳnh Mẫn Đạt, Phường Chợ Quán (P.1, Quận 5 cũ), TP.HCM",
      dienTich:"Ngang 15m x Dài 35m, Công nhận 420m², DTS 2197,4m²",
      ketCau: "Hầm 7 tầng",
      giaBan: "240 tỷ",
      hopDong:"630 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nam Huỳnh Mẫn Đạt với Trần Hưng Đạo",
      allPhoto: ["67.1.jpg", "67.2.jpg", "67.3.jpg", "67.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: " 0913775579 Anh Dũng - 0908273004- Anh Tuấn HT CHủ nhà",
      map: "",
    },
     {
      ma: "68",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "3-5 Pasteur",
      address: "3-5 Pasteur, Phường Sài Gòn (P.Nguyễn Thái Bình, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 7,9m x Dài 19,4m, Công nhận 153,2m², DTS 1118m²",
      ketCau: "Hầm 9 tầng",
      giaBan: "250 tỷ",
      hopDong:"430 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường 3-5 Pasteur với Nguyễn Công Trứ",
      allPhoto: ["68.1.jpg", "68.2.jpg", "68.3.jpg", "68.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0913901205 Chú Huệ",
      map: "",
    },
     {
      ma: "69",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "140 Trần Quang Khải",
      address: "140 Trần Quang Khải, Phường Tân Định (P.Tân Định, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 8m x Dài 15m, Công nhận 99,8m², DTS 399,1m²",
      ketCau: "6 tầng",
      giaBan: "85 tỷ",
      hopDong:"200 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Trần Quang Khải với Trần Khắc Chân",
      allPhoto: ["69.1.jpg", "69.2.jpg", "69.3.jpg", "69.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0973618631 Đô Phan",
      map: "",
    },
     {
      ma: "70",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "42 Lê Thánh Tôn",
      address: "42 Lê Thánh Tôn, Phường Sài Gòn (P.Bến Nghé, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 4,4m x Dài 21m, Công nhận 92,4m², DTS 626,6m²",
      ketCau: "Hầm 8 tầng",
      giaBan: "120 tỷ",
      hopDong:"240 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Lê Thánh Tôn với Thái Văn Lung",
      allPhoto: ["70.1.jpg", "70.2.jpg", "70.3.jpg", "70.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909901809 Chị Huyền",
      map: "",
    },
      {
      ma: "71",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "186-186Bis Nguyễn Thị Minh Khai",
      address: "186-186Bis Nguyễn Thị Minh Khai, Phường Xuân Hoà (P.Võ Thị Sáu, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 9,5m x Dài 29m, Nở hậu 11,7m, Công nhận 285m², DTS 2478,7m²",
      ketCau: "Hầm 13 tầng",
      giaBan: "330 tỷ",
      hopDong:"1.000 Triệu/tháng",
      huong: "Đông Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Thị Minh Khai với Trương Định",
      allPhoto: ["71.1.jpg", "71.2.jpg", "71.3.jpg", "71.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0343676392 Cô Hằng",
      map: "",
    },
     {
      ma: "72",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "10A Nguyễn Thị Minh Khai",
      address: "10A Nguyễn Thị Minh Khai, Phường Xuân Hoà (P.Võ Thị Sáu, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 18m x Dài 18m, Công nhận 188,9m², DTS 2148m²",
      ketCau: "Hầm 10 tầng",
      giaBan: "330 tỷ",
      hopDong:"1.000 Triệu/tháng",
      huong: "Đông Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Thị Minh Khai với Nguyễn Bỉnh Khiêm",
      allPhoto: ["72.1.jpg", "72.2.jpg", "72.3.jpg", "72.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0963542689 Anh Uẩn",
      map: "",
    },
    {
      ma: "73",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "215A-215B Hai Bà Trưng",
      address: "215A-215B Hai Bà Trưng, Phường Xuân Hoà (P.Võ Thị Sáu, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 7,3m x Dài 24,08m, Công nhận 167,8m², DTS 530,1m²",
      ketCau: "3 tầng",
      giaBan: "192 tỷ",
      hopDong:"200 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường 215A-215B Hai Bà Trưng với Võ Thị Sáu",
      allPhoto: ["73.1.jpg", "73.2.jpg", "73.3.jpg", "73.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 Anh Nam",
      map: "",
    },
     {
      ma: "74",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: " 22 Nguyễn An Ninh",
      address: " 22 Nguyễn An Ninh, Phường Bến Thành (P.Bến Thành, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 4m x Dài 23m, Công nhận 88m², DTS 587,3m²",
      ketCau: "Hầm 9 tầng",
      giaBan: "93 tỷ",
      hopDong:"250 Triệu/tháng",
      huong: "Đông Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn An Ninh với Phan Chu Trinh",
      allPhoto: ["74.1.jpg", "74.2.jpg", "74.3.jpg", "74.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 Anh Nam",
      map: "",
    },
     {
      ma: "75",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "56 Nguyễn Đình Chiểu",
      address: "56 Nguyễn Đình Chiểu, Phường Tân Định (P.Đakao, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 19m x Dài 27m, Công nhận 508m², DTS 4290m²",
      ketCau: "2 Hầm 14 tầng",
      giaBan: "1000 tỷ",
      hopDong:"4tỷ/tháng",
      huong: "Đông Nam & Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Đình Chiểu với Phan Kế Bính",
      allPhoto: ["75.1.jpg", "75.2.jpg", "75.3.jpg", "75.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 Anh Nam",
      map: "",
    },
    {
      ma: "76",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "170-172 Nam Kỳ Khởi Nghĩa",
      address: "170-172 Nam Kỳ Khởi Nghĩa, Phường Xuân Hoà (P.Võ Thị Sáu, Quận 3 cũ), TP.HCM",
      dienTich:"Ngang 8,3m x Dài 42m, Công nhận 388m², DTS 1600m²",
      ketCau: "Hầm 7 tầng",
      giaBan: "250 tỷ",
      hopDong:"4tỷ/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nam Kỳ Khởi Nghĩa với Nguyễn Thị Minh Khai",
      allPhoto: ["76.1.jpg", "76.2.jpg", "76.3.jpg", "76.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909024744 Chị Hà - 0389997079 Chị Lãnh đại diện",
      map: "",
    },
     {
      ma: "77",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "1 Trần Nhật Duật",
      address: "1 Trần Nhật Duật, Phường Tân Định (P.Tân Định, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 7,8m x Dài 15,5m, Công nhận 121m², DTS 569,4m²",
      ketCau: "Hầm 7 tầng",
      giaBan: "79 tỷ",
      hopDong:"320 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Trần Nhật Duật với Trần Quang Khải",
      allPhoto: ["77.1.jpg", "77.2.jpg", "77.3.jpg", "77.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909024744 Chị Hà - 0389997079 Chị Lãnh đại diện",
      map: "",
    },
    {
      ma: "78",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "265-267 Trần Bình Trọng",
      address: "265-267 Trần Bình Trọng, Phường Chợ Quán (P.4, Quận 5 cũ), TP.HCM",
      dienTich:"Ngang 10,2m x Dài 22m, Công nhận 224,4m², DTS 1184,9m²",
      ketCau: "Hầm 7 tầng",
      giaBan: "155 tỷ",
      hopDong:"300 Triệu/tháng",
      huong: "Đông Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Trần Bình Trọng với Hùng Vương",
      allPhoto: ["78.1.jpg", "78.2.jpg", "78.3.jpg", "78.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909024744 Chị Hà - 0389997079 Chị Lãnh đại diện",
      map: "",
    },
     {
      ma: "79",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "27A-27B Trần Nhật Duật",
      address: "27A-27B Trần Nhật Duật, Phường Tân Định (P.TĐ, Quận 1 cũ), TP.HCM",
      dienTich:"Ngang 24m x Dài 24m, Công nhận 525,7m², DTS 964,8m²",
      ketCau: "5 tầng",
      giaBan: "195 tỷ",
      hopDong:"425 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Trần Nhật Duật với Trần Quang Khải",
      allPhoto: ["79.1.jpg", "79.2.jpg", "79.3.jpg", "79.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0908957788 - 0989128228 - Quách Quế Tiến",
      map: "",
    },
     {
      ma: "80",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "284-286 Nguyễn Gia Trí(D2)",
      address: "284-286 Nguyễn Gia Trí(D2), Phường Thạnh Mỹ Tây (P.25, Quận Bình Thạnh cũ), TP.HCM",
      dienTich:"Ngang 10m x Dài 20m, Công nhận 186,3m², DTS 419,8m²",
      ketCau: "5 tầng",
      giaBan: "58 tỷ",
      hopDong:"80 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Gia Trí với Điện Biên Phủ",
      allPhoto: ["80.1.jpg", "80.2.jpg", "80.3.jpg", "80.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0902629636 Chị Oanh",
      map: "",
    },
      {
      ma: "81",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "275 Điện Biên Phủ",
      address: "275 Điện Biên Phủ, Phường Bình Thạnh  (P.15, Quận Bình Thạnh cũ), TP.HCM",
      dienTich:"Ngang 5,5m x Dài 32m, Công nhận 169,8m², DTS 285,1m²",
      ketCau: "2 tầng (GPXD7-12 tầng)",
      giaBan: "54 tỷ",
      hopDong:"150 Triệu/tháng",
      huong: "Tây Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Điện Biên Phủ với Đinh Bộ Lĩnh",
      allPhoto: ["81.1.jpg", "81.2.jpg", "81.3.jpg", "81.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0974447777- 0919555558 Tin",
      map: "",
    },
     {
      ma: "82",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "12 Nguyễn Văn Trỗi",
      address: "12 Nguyễn Văn Trỗi, Phường Phú NHuận  (P.15, Quận Phú Nhuận cũ), TP.HCM",
      dienTich:"Ngang 7,5m x Dài 12,5m, Công nhận 93m², DTS 219,5m²",
      ketCau: "3 tầng",
      giaBan: "60 tỷ",
      hopDong:"100 Triệu/tháng",
      huong: "Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Văn Trỗi với Trường Sa",
      allPhoto: ["82.1.jpg", "82.2.jpg", "82.3.jpg", "82.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 A Nam",
      map: "",
    },
     {
      ma: "83",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "640-640A-642 Cộng Hoà",
      address: "640-640A-642 Cộng Hoà, Phường Tân Bình  (P.13, Quận Tân Bình cũ), TP.HCM",
      dienTich:"Ngang 12m x Dài 27,5m, Công nhận 274,8m², DTS 219,5m²",
      ketCau: "4 tầng",
      giaBan: "85 tỷ",
      hopDong:"200 Triệu/tháng",
      huong: "Tây Nam",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Cộng Hoà với Phan Văn Sửu",
      allPhoto: ["83.1.jpg", "83.2.jpg", "83.3.jpg", "83.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0918480408 Chị Linh",
      map: "",
    },
     {
      ma: "84",
      proName: "TOÀ NHÀ VĂN PHÒNG",
      title: "23 Nguyễn Thị Huỳnh,",
      address: "23 Nguyễn Thị Huỳnh,, Phường Phú Nhuận  (P.8, Quận Phú Nhuận cũ), TP.HCM",
      dienTich:"Ngang 12,4m x Dài 46m, Nở hậu 21m, Công nhận 723,1m², DTS 3752,8m²",
      ketCau: "2 Hầm 9 tầng",
      giaBan: "222 tỷ",
      hopDong:"700 Triệu/tháng",
      huong: "Đông Bắc",
      phapLy: "Cá nhân",
      viTri: "Giữa đường Nguyễn Thị Huỳnh, với Nguyễn Văn Trỗi",
      allPhoto: ["84.1.jpg", "84.2.jpg", "84.3.jpg", "84.4.jpg"],
      categories: ["Nhà phố", "Building"],
      chuNha: "0909762672 A Nam",
      map: "",
    },
  ],
};

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    updateLogin(state, action) {
      state.login = action.payload;
    },
    updateOverlay(state, action) {
      state.overlay = action.payload;
    },
    updateSelectedCategory(state, action) {
      state.selectedCategory = action.payload;
    },
  },
});

export const { updateLogin, updateOverlay, updateSelectedCategory } =
  dataSlice.actions;
export default dataSlice.reducer;

